<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['websites.menu'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'WEBSITES.WEBSITES_LIST.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <button
        *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['websites.store'])"
        type="button"
        class="btn btn-secondary"
        (click)="add()"
      >
        {{ 'WEBSITES.WEBSITES_LIST.ADD_WEBSITE' | translate }}
      </button>
    </div>
  </div>

  <kendo-grid
    [data]="data"
    [pageSize]="websitesResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Websites', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'WEBSITES.WEBSITES_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'WEBSITES.WEBSITES_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="name"
      title="{{ 'WEBSITES.WEBSITES_LIST.NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('name')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="company.abbreviation"
      title="{{ 'WEBSITES.WEBSITES_LIST.COMPANY_NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('company.abbreviation')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-company-select [filter]="filter" [field]="'company_id'"></app-kendo-company-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.company?.shortName }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="url"
      title="{{ 'WEBSITES.WEBSITES_LIST.URL' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('url')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="updated_at"
      title="Updated at"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('updated_at')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.updated_at?.getDateTime() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="webhook_url"
      title="{{ 'WEBSITES.WEBSITES_LIST.WEBHOOK_URL' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('company.webhook_url')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="webhook_secret"
      title="{{ 'WEBSITES.WEBSITES_LIST.WEBHOOK_SECRET' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('company.webhook_secret')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="webhook_active"
      title="{{ 'WEBSITES.WEBSITES_LIST.WEBHOOK_ACTIVE' | translate }}"
      filter="boolean"
      [width]="150"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('webhook_active')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.webhook_active"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="active"
      title="{{ 'WEBSITES.WEBSITES_LIST.ACTIVE' | translate }}"
      filter="boolean"
      [width]="150"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('active')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.active"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'WEBSITES.WEBSITES_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-edit-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['websites.show'])"
          (click)="edit(dataItem)"
        >
        </app-edit-button>

        <app-delete-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['websites.destroy'])"
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
